import Vue from 'vue'
import Vuex from 'vuex'

import apolloClient from './graphqlclient'
import { currentUserQuery } from "@/graphql/userQueries.gql";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentUser: null
  },
  mutations: {
    setCurrentUser(state, currentUser) { state.currentUser = currentUser },
  },
  actions: {
    fetchCurrentUser({ commit }) {
      console.log('fetch current user', localStorage.token)
      return apolloClient.query({ query: currentUserQuery }).then( (response) => {
        commit('setCurrentUser', response.data.currentUser)
      })
    }
  }
})
